'use client'
import * as React from 'react'

import { Switch } from '@/components/ui/switch'
import {
  SidebarContent,
  SidebarGroup,
  SidebarSeparator,
} from '@/components/ui/sidebar'

export function AppSidebarContent() {
  const [pauseAll, setPauseAll] = React.useState(false)
  const [switches, setSwitches] = React.useState({
    latestContests: false,
    interestedContests: false,
    recommendedContests: false,
    featureUpdates: false,
    personalEmail: false,
    contestorWebsite: false,
  })

  // Handle the "Pause All" switch
  const handlePauseAllSwitchChange = (checked: boolean) => {
    setPauseAll(checked)
    if (checked) {
      // Turn off all switches when "Pause All" is turned on
      setSwitches({
        latestContests: false,
        interestedContests: false,
        recommendedContests: false,
        featureUpdates: false,
        personalEmail: false,
        contestorWebsite: false,
      })
    }
  }

  // Check if any switch is selected
  const isAnySwitchSelected =
    pauseAll || Object.values(switches).some((value) => value)

  // Handle individual switches
  const handleIndividualSwitchChange = (
    key: keyof typeof switches,
    checked: boolean
  ) => {
    setSwitches((prev) => ({ ...prev, [key]: checked }))
    if (checked) {
      setPauseAll(false) // Turn off "Pause All" when any individual switch is turned on
    }
  }

  return (
    <>
      <div>
        <SidebarSeparator className="mx-0 h-[0.5px] bg-black" />
        <SidebarContent>
          <SidebarGroup>
            <div className="mx-5">
              <div className="space-y-10">
                <div className="space-y-6">
                  <div className="flex flex-col space-y-6">
                    <div className="space-y-0.5">
                      <h1 className="text-[16px] font-bold text-zinc-950">
                        Push Notifications
                      </h1>
                      <label className="text-[14px] text-zinc-500">
                        รับแจ้งเตือนเรื่องอะไรบ้าง
                      </label>
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="space-y-0.5">
                        <h1 className="text-[16px] font-bold text-zinc-950">
                          Pause all
                        </h1>
                        <label className="text-[14px] text-zinc-500">
                          หยุดการแจ้งเตือนทุกประเภทชั่วคราว
                        </label>
                      </div>
                      <Switch
                        checked={pauseAll}
                        onCheckedChange={handlePauseAllSwitchChange}
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <h1 className="text-[16px] font-bold text-zinc-950">
                        ข่าวสารงานแข่งล่าสุด
                      </h1>
                      <Switch
                        checked={switches.latestContests}
                        onCheckedChange={(checked) =>
                          handleIndividualSwitchChange(
                            'latestContests',
                            checked
                          )
                        }
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <h1 className="text-[16px] font-bold text-zinc-950">
                        งานแข่งที่ตรงกับความสนใจ
                      </h1>
                      <Switch
                        checked={switches.interestedContests}
                        onCheckedChange={(checked) =>
                          handleIndividualSwitchChange(
                            'interestedContests',
                            checked
                          )
                        }
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <h1 className="text-[16px] font-bold text-zinc-950">
                        งานแข่งแนะนำ
                      </h1>
                      <Switch
                        checked={switches.recommendedContests}
                        onCheckedChange={(checked) =>
                          handleIndividualSwitchChange(
                            'recommendedContests',
                            checked
                          )
                        }
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <h1 className="text-[16px] font-bold text-zinc-950">
                        Update ฟีเจอร์ใหม่ของ Contester Life
                      </h1>
                      <Switch
                        checked={switches.featureUpdates}
                        onCheckedChange={(checked) =>
                          handleIndividualSwitchChange(
                            'featureUpdates',
                            checked
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="space-y-6">
                  <div className="flex flex-col space-y-6">
                    <div className="space-y-0.5">
                      <h1 className="text-[16px] font-bold text-zinc-950">
                        Notification Channels
                      </h1>
                      <label className="text-[14px] text-zinc-500">
                        รับแจ้งเตือนผ่านช่องทางไหนบ้าง
                      </label>
                    </div>
                    <div className="flex items-center justify-between">
                      <h1 className="text-[16px] font-bold text-zinc-950">
                        Personal Email
                      </h1>
                      <Switch
                        checked={switches.personalEmail}
                        onCheckedChange={(checked) =>
                          handleIndividualSwitchChange('personalEmail', checked)
                        }
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <h1 className="text-[16px] font-bold text-zinc-950">
                        Contester Life Website
                      </h1>
                      <Switch
                        checked={switches.contestorWebsite}
                        onCheckedChange={(checked) =>
                          handleIndividualSwitchChange(
                            'contestorWebsite',
                            checked
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`mt-[189px] flex w-auto cursor-pointer items-center justify-center rounded-full px-4 py-2 text-[14px] font-bold ${
                isAnySwitchSelected
                  ? 'bg-black text-white'
                  : 'bg-white text-black'
              }`}
            >
              Save preferences
            </div>
          </SidebarGroup>
        </SidebarContent>
      </div>
    </>
  )
}
